import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { setActiveStep } from '@src/store/slice/autoUploadInstructionsSlice';

import { CustomImage, Text, useText } from '@src/components';

import { Button } from 'antd';

import iconSuccess from '@src/assets/icons/icon-success.svg';
import '@src/styles/autoUploadInstruction/completed.scss';

const Completed = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { totalAutoLoading } = useSelector((state) => state?.autoUploadInstructions);

  const iDonTWantToApproveEveryMonthNotice = useText('iDonTWantToApproveEveryMonthNotice');
  const iWantToApproveEveryMonthNotice = useText('iWantToApproveEveryMonthNotice');

  const redirectToHomePage = useCallback(() => {
    history.push('/dashboard');
    dispatch(setActiveStep(0));
  }, [dispatch, history]);

  const confirmText = () => {
    return totalAutoLoading.confirmEveryMonth === 0
      ? iDonTWantToApproveEveryMonthNotice
      : iWantToApproveEveryMonthNotice;
  };

  return (
    <div className="autoUploadInstruction-instruction-completed-content">
      <div className="success-order-header-content">
        <CustomImage src={iconSuccess} />
        <div className="success-order-header-content-title">
          <h1>
            <Text t="thankYou" />
          </h1>
        </div>
        <div className="success-order-header-content-subTitle">
          <span>
            <Text t="yourAutomaticLoadingInstructionHasBeenSuccessfullySaved" />
          </span>
        </div>
      </div>

      <div className="description-list">
        <p>
          <Text t="yourOrderWillBeCreatedAutomaticallyEveryMonth" />
        </p>
        <p>{confirmText()}</p>
        <p>
          <Text t="autoUploadInstructions.detailsNotice" />
        </p>
      </div>

      <div className="footer-content">
        <Button
          id="redirect"
          data-testid="redirect"
          onClick={redirectToHomePage}
          className="footer-content-button"
        >
          <span>
            <Text t="goToHomepage" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default Completed;
